function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var IPTVPlatform;
(function(IPTVPlatform) {
    IPTVPlatform[IPTVPlatform["Apollo"] = 1] = "Apollo";
})(IPTVPlatform || (IPTVPlatform = {}));
export var iptvPlatformNames = _defineProperty({}, IPTVPlatform.Apollo, "Apollo");
